export default {
  filter: {
    users: {
      placeholder: 'حدد المستخدم'
    },
    status: {
      placeholder: 'جميع الحالات'
    }
  },
  table: {
    amount: 'المجموع',
    generated_for: 'أنشأت من أجل',
    status: 'الحالة',
    plan: 'الخطة',
    due_at: 'المستحق في',
    actions: {
      title: 'الإجراءات',
      tooltip: {
        view_details: 'عرض التفاصيل',
        pay_invoice: 'دفع الفاتورة'
      }
    },
    created_at: 'تم إنشاؤه في',
    invoice_id: 'معرف الفاتورة'
  },
  buttons: {
    pay_invoice: 'دفع الفاتورة',
    change_payment_method: 'تغيير طريقة الدفع'
  },
  invoice_details: {
    title: 'تفاصيل الفاتورة',
    general_info: {
      title: 'معلومات عامة',
      fields: {
        invoice_id: 'معرف الفاتورة',
        generated_at: 'تم إنشاؤه في',
        generated_for: 'أنشأت من أجل',
        amount: 'المجموع',
        payment_id: 'معرف الدفع',
        paid_at: 'تم الدفع في',
        status: 'الحالة'
      }
    },
    payment_info: {
      title: 'معلومات الدفع',
      fields: {
        payment_card: 'بطاقة الدفع'
      }
    },
    buttons: {
      close: 'غلق'
    }
  }
};